import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../shared/Modal';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'imprint' | null>(null);

  const openModal = (modal: 'privacy' | 'terms' | 'imprint') => {
    setActiveModal(modal);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const legalContent = {
    privacy: {
      title: t('modals.privacy.title'),
      content: t('modals.privacy.content'),
    },
    terms: {
      title: t('modals.terms.title'),
      content: t('modals.terms.content'),
    },
    imprint: {
      title: t('modals.imprint.title'),
      content: t('modals.imprint.content'),
    },
  };

  return (
    <>
      <footer className="bg-dark-secondary border-t border-dark-border/20 py-16 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {/* Brand */}
            <div className="col-span-1 lg:col-span-2">
              <div className="flex flex-col items-center sm:items-start">
                <img 
                  src="/logo.png" 
                  alt="TamerinTECH Logo" 
                  className="w-full max-w-[95%] sm:max-w-[90%] lg:max-w-[80%] h-auto object-contain mb-4"
                />
                <p className="text-cream-dark leading-relaxed text-sm sm:text-base lg:text-lg text-center sm:text-left">
                  {t('footer.description')}
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-playfair text-base sm:text-lg font-light text-cream mb-4 sm:mb-6 tracking-wide text-center sm:text-left">{t('footer.quickLinks')}</h4>
              <ul className="space-y-2 sm:space-y-3 text-center sm:text-left">
                <li>
                  <a
                    href="https://www.tamerin.tech"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cream-dark hover:text-gold transition-colors duration-300 font-light"
                  >
                    {t('footer.homepage')}
                  </a>
                </li>
                <li>
                  <a
                    href="#preview-gallery"
                    className="text-cream-dark hover:text-gold transition-colors duration-300 font-light"
                  >
                    {t('nav.gallery')}
                  </a>
                </li>
                <li>
                  <a
                    href="#faq"
                    className="text-cream-dark hover:text-gold transition-colors duration-300 font-light"
                  >
                    FAQ
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="text-cream-dark hover:text-gold transition-colors duration-300 font-light"
                  >
                    {t('nav.contact')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="font-playfair text-base sm:text-lg font-light text-cream mb-4 sm:mb-6 tracking-wide text-center sm:text-left">{t('footer.legal')}</h4>
              <ul className="space-y-2 sm:space-y-3 text-center sm:text-left">
                <li>
                  <button
                    onClick={() => openModal('privacy')}
                    className="text-cream-dark hover:text-gold transition-colors duration-300 text-left font-light"
                  >
                    {t('footer.privacy')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => openModal('terms')}
                    className="text-cream-dark hover:text-gold transition-colors duration-300 text-left font-light"
                  >
                    {t('footer.terms')}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => openModal('imprint')}
                    className="text-cream-dark hover:text-gold transition-colors duration-300 text-left font-light"
                  >
                    {t('footer.imprint')}
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-dark-border/20 text-center">
            <p className="text-cream-dark font-light text-sm sm:text-base">
              © 2025 TamerinTECH GmbH
            </p>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      {activeModal && (
        <Modal
          isOpen={!!activeModal}
          onClose={closeModal}
          title={legalContent[activeModal].title}
          maxWidth="max-w-4xl"
        >
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{
              __html: legalContent[activeModal].content,
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default Footer;